import store from '@/store'

/**
 * 是否需要登录（任一匹配记录声明 requiresAuth: true）
 */
export function routeRequiresAuth(to) {
  return to.matched.some((r) => r.meta.requiresAuth === true)
}

/**
 * 全局前置守卫：根路径、登录态、菜单权限
 */
export function createBeforeEachGuard() {
  return function beforeEach(to, from, next) {
    const authed = store.getters.isAuthenticated

    // 1) 根路径 / ：未登录必须进登录页（避免先命中布局再重定向造成误判）
    if (to.path === '/') {
      if (!authed) {
        next({ name: 'Login', replace: true })
        return
      }
      next({ path: '/admin/home', replace: true })
      return
    }

    // 2) 需要登录的路由
    if (routeRequiresAuth(to) && !authed) {
      next({
        name: 'Login',
        replace: true,
        query: to.fullPath !== '/login' ? { redirect: to.fullPath } : undefined
      })
      return
    }

    // 3) 已登录访问登录页 → 进后台首页
    if (to.meta.guestOnly === true && authed) {
      next({ path: '/admin/home', replace: true })
      return
    }

    // 4) 路由 meta.auth 权限（后端 auths 列表）
    const leaf = to.matched[to.matched.length - 1]
    const meta = leaf?.meta || {}
    if (
      authed &&
      meta.requiresAuth &&
      meta.auth &&
      !meta.skipPermission
    ) {
      if (!store.getters.hasAuth(meta.auth)) {
        next({ name: 'Forbidden', replace: true })
        return
      }
    }

    next()
  }
}
